import { RatingDescription } from './rating-description.model';
import { ReservationTypeEnum } from './reservation-type.model';

export enum AccommodationItemVariantEnum {
    Map = 'map',
}

export interface AccommodationItemModel {
    id: string;
    name: string;
    path: string;
    images: { default: boolean; url: string }[];
    settlementName: string;
    distanceFromCityCentre: number | null;
    ratingsAverage?: number;
    ratingDescription?: RatingDescription;
    ratingsCount: number;
    cheapestRate: {
        rate: number;
        baseRate: number;
        guests: number;
        children: number;
        childrenAges?: number[];
        duration: number;
        currency: string;
    };
    checkInDate?: Date;
    checkOutDate?: Date;
    reservationType?: ReservationTypeEnum;
    variant?: AccommodationItemVariantEnum;
}
